import { LayoutTypes, TopbarTheme } from '../../../../constants/layout';

export enum LayoutActionTypes {
  CHANGE_LAYOUT = '@@layout/CHANGE_LAYOUT',
  CHANGE_TOPBAR_THEME = '@@layout/CHANGE_TOPBAR_THEME',
}

export type LayoutStateTypes = {
  layoutType: LayoutTypes.LAYOUT_HORIZONTAL;
  topbarTheme: TopbarTheme.TOPBAR_THEME_LIGHT | TopbarTheme.TOPBAR_THEME_DARK;
};
